import React, { useEffect, useState } from "react";
import {  Row, Col, Checkbox, Typography } from "antd";
import API_KEY from "../../../../api/index";
import { gaEvent } from "analytics/analytics";
import * as GA from "constants/analytics";

const { Text,Title } = Typography;
export default function FieldsCategoryTabs({ category, handleCheckboxChange }) {
  const [categoryData, setCategoryData] = useState(null);
  // const [visibleAttrs, setVisibleAttrs] = useState([])
  useEffect(() => {
    API_KEY.URL.get(`${API_KEY.path.secondaryCategory}/${category?.id}`, {
      params: {
        fields: "*,attributes.*,attributes.attributes_id.*",
      },
    })
      .then((res) => {
        const attributes = res?.data?.data?.attributes;
        setCategoryData(attributes);
        // setTableLoading(false);
        // setAttributes(attributes);
      })
      .catch((error) => console.log(error));
  }, [category]);
  // useEffect(() => {
  //    const attrs = category?.values?.map((attr) => attr.visible_attributes);
  //   if (attrs?.length > 0){
  //       setVisibleAttrs( [...new Set(attrs.flat())] ,'attrs');
  //       console.log( [...new Set(attrs.flat())] ,'attrs')
  //   }
   
  // }, [category])
  
 
  return (
    <Row>
     <Row>
       <Col>
       <Title level={5} >Select fields to show for <Text style={{fontFamily:'Gilroy'}}>{category?.name}</Text></Title>
       </Col>
     </Row>
      <Row>
      {categoryData?.map(
        (attr) =>
          !attr?.attributes_id?.is_internal && attr?.attributes_id?.dtype !== "file" && (
            <Col span={12} style={{ marginTop: "0.5em" }} key={attr.id}>
               <Checkbox
                checked={category?.values?.[0]?.visible_attributes?.includes(`${attr?.attributes_id?.id}`)}
                onChange={(e) => {
                  handleCheckboxChange(e, attr?.attributes_id, category)
                  gaEvent(GA.EVENT.CLICK, GA.CATEGORY.CREATE_COLLECTION, GA.DESCRIPTION.CREATE_COLLECTION_CUSTOMER_BUYER_VIEW_CHECKED);
                }}
                
              >
                <Text style={{fontSize:15}}> {attr?.attributes_id?.name}</Text>
              </Checkbox> 
             
           
            </Col>
          )
      )}
      </Row>
    </Row>
  );
}
